import * as React from "react";
const SvgVisibility = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M12 16q1.875 0 3.187-1.312Q16.5 13.375 16.5 11.5t-1.313-3.187T12 7 8.812 8.313 7.5 11.5t1.312 3.188T12 16m0-1.8q-1.125 0-1.913-.787A2.6 2.6 0 0 1 9.3 11.5q0-1.125.787-1.912A2.6 2.6 0 0 1 12 8.8q1.125 0 1.912.787.788.788.788 1.913t-.788 1.912A2.6 2.6 0 0 1 12 14.2m0 4.8q-3.349 0-6.113-1.8-2.761-1.8-4.362-4.75a1.907 1.907 0 0 1-.187-1.437q.062-.238.187-.463 1.6-2.95 4.362-4.75T12 4t6.112 1.8 4.363 4.75a1.906 1.906 0 0 1 .188 1.438 2 2 0 0 1-.188.462q-1.6 2.95-4.363 4.75Q15.35 19 12 19m0-2a9.54 9.54 0 0 0 5.187-1.488A9.77 9.77 0 0 0 20.8 11.5a9.77 9.77 0 0 0-3.613-4.012A9.55 9.55 0 0 0 12 6a9.55 9.55 0 0 0-5.188 1.487A9.77 9.77 0 0 0 3.2 11.5a9.77 9.77 0 0 0 3.612 4.012A9.54 9.54 0 0 0 12 17"
    />
  </svg>
);
export default SvgVisibility;
